<template>
  <div class="reviews-page">

    <!-- ===== METRICS STRIP ===== -->
    <div class="metrics-grid">

      <div class="metric-card">
        <div class="metric-head">
          <span>Avg. Rating</span>
          <span class="material-symbols-outlined primary">star_half</span>
        </div>
        <div class="metric-value">
          {{ kpis.avg_rating }}
        </div>
      </div>

      <div class="metric-card">
        <div class="metric-head">
          <span>Total Reviews</span>
          <span class="material-symbols-outlined primary">chat_bubble</span>
        </div>
        <div class="metric-value">
          {{ kpis.total_reviews }}
        </div>
      </div>

      <div class="metric-card">
        <div class="metric-head">
          <span>Negative Reviews</span>
          <span class="material-symbols-outlined danger">mood_bad</span>
        </div>
        <div class="metric-value">
          {{ kpis.negative_reviews }}
        </div>
      </div>

      <div class="metric-card">
        <div class="metric-head">
          <span>Positive Reviews</span>
          <span class="material-symbols-outlined warning">bolt</span>
        </div>
        <div class="metric-value">
          {{ kpis.review_velocity }}
        </div>
      </div>

    </div>

    <!-- ===== TOOLBAR ===== -->
    <div class="toolbar">

      <div class="toolbar-left">

        <div class="search-box">
          <span class="material-symbols-outlined">search</span>
          <input v-model="searchQuery" placeholder="Search customer names or text..." />

        </div>

        <div class="dropdown-wrapper">

          <button id="platformBtn" class="filter-btn" @click="togglePlatformDropdown">

            <span class="material-symbols-outlined">public</span>

            Platform: {{ selectedPlatform }}

            <span class="material-symbols-outlined">expand_more</span>

          </button>

          <!-- Dropdown -->
          <div id="platformDropdown" v-if="activePopup === 'platform'" class="dropdown-menu">

            <div @click="selectPlatform('All')">All Platforms</div>
            <div @click="selectPlatform('custom')">Custom</div>
            <div @click="selectPlatform('google')">Google</div>
            <div @click="selectPlatform('facebook')">Facebook</div>

          </div>

        </div>


        <div class="dropdown-wrapper">

          <button id="dateBtn" class="filter-btn" @click="toggleDateDropdown">

            <span class="material-symbols-outlined">calendar_today</span>

            {{ selectedDate }}

            <span class="material-symbols-outlined">expand_more</span>

          </button>
          <!-- Dropdown -->
          <div id="dateDropdown" v-if="activePopup === 'date'" class="dropdown-menu">

            <div @click="selectDate('Today')">Today</div>
            <div @click="selectDate('Last 7 Days')">Last 7 Days</div>
            <div @click="selectDate('Last 30 Days')">Last 30 Days</div>
            <div @click="selectDate('Last 90 Days')">Last 90 Days</div>

          </div>

        </div>
        <!-- ===== STAR FILTERS ===== -->
        <div class="top-filters">


          <!-- Star Filter Dropdown -->
          <div class="dropdown-wrapper">

            <button
              class="tab-btn"
              :class="{ active: activeStarFilters.length > 0 }"
              @click="toggleStarDropdown"
            >
              Reviewed 1–5 Stars
              <span class="material-symbols-outlined small-icon">
                expand_more
              </span>
            </button>

            <div
              v-if="activePopup === 'stars'"
              class="dropdown-menu star-dropdown"
            >

              <label v-for="star in 5" :key="star" class="checkbox-row">
                <input
                  type="checkbox"
                  :value="star"
                  v-model="activeStarFilters"
                />
                {{ star }} Star
              </label>

              <div class="dropdown-actions">
                <button class="ghost-btn small" @click="clearStars">
                  Clear
                </button>

                <button class="primary-btn small" @click="applyStarFilter">
                  Apply
                </button>
              </div>

            </div>

          </div>

        </div>

      </div>

      <div class="toolbar-right">
        <div class="dropdown-wrapper">

          <button id="campformBtn" class="filter-btn" @click="toggleCamppDropdown">

            <span class="material-symbols-outlined">campaign</span>

            Campaign: {{ selectedCampName }}

            <span class="material-symbols-outlined">expand_more</span>

          </button>

          <!-- Dropdown -->
          <div id="campDropdown" v-if="activePopup === 'camp'" class="dropdown-menu">

            <div @click="selectCamp('','All')">All</div>
            <div v-for="cmp in camps" :key="cmp.camp_id" @click="selectCamp(cmp.camp_id,cmp.camp_title)">{{ cmp.camp_title }}</div>
          </div>

        </div>


        <button @click="expNow()" class="primary-btn">
          <span class="material-symbols-outlined">download</span>
          Export
        </button>
      </div>

    </div>

    <!-- ===== TABLE ===== -->
    <div class="table-card">

      <table>
        <thead>
          <tr>
            <th style="text-align: left;">Customer</th>
            <th style="text-align: left;">Contact</th>
            <th style="text-align: left;">Rating</th>
            <th style="text-align: left;">Review Text</th>
            <th style="text-align: left;">Ai Replay</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="review in reviews" :key="review.review_id">

            <td>
              <div class="customer-cell">
                <img :src="platformLogo(review.review_platform,review.review_rating)" class="source-logo" />
                <span>{{ review.review_name }}</span>

              </div>
              <small style="margin-left: 2.3rem; margin-top: .5rem;">{{ beautifyDate(review.review_datetime) }}</small>
            </td>

             <td>
              <div>
                <span v-if="isEmail(review.review_email)">{{ review.review_email }}</span><br>
                <span style="margin-top: 1rem;">{{ review.review_mobile }}</span>
              </div>
            </td>

            <td>
              <div class="stars">
                <span v-for="i in 5" :key="i" class="material-symbols-outlined"
                  :class="{ filled: i <= parseInt(review.review_rating) }">
                  star
                </span>
              </div>
            </td>

            <td class="review-text">
              <span v-if="showTxt!=review.review_id">{{ getShrt(review.review_feedback) || "-"}}</span>
                    <span v-if="showTxt===review.review_id">{{ review.review_feedback || "-"}}</span>
                    <a style="margin-left: 1rem;" v-if="showTxt!=review.review_id && review.review_feedback.length>100" @click="readMore(review.review_feedback,review.review_id,1)">Read More</a>
                    <a style="margin-left: 1rem;" v-if="showTxt===review.review_id && review.review_feedback.length>100" @click="readMore(review.review_feedback,review.review_id,0)">Read Less</a>
                  
            </td>

            <td class="right">
             <button
              v-if="review.review_status==='active'"
              class="ai-btn"
              @click="openAiReply(review)"
            >
              ✨ AI Reply
            </button>
            <button
              v-if="review.review_status==='Ai Replied'"
              class="ai-btn"
            >
              AI Replied
            </button>
            </td>

          </tr>
        </tbody>
      </table>

      <div class="pagination">

        Showing
        {{ page * pageSize + 1 }}
        –
        {{ Math.min((page + 1) * pageSize, totalReviews) }}
        of {{ totalReviews }} reviews

        <div class="pages">

          <button @click="prevPage" :disabled="page === 0">
            <span class="material-symbols-outlined">chevron_left</span>
          </button>

          <button class="active">
            {{ page + 1 }}
          </button>

          <button @click="nextPage" :disabled="page + 1 >= totalPages">
            <span class="material-symbols-outlined">chevron_right</span>
          </button>

        </div>

      </div>

    </div>
<div v-if="aiModal" class="fixed inset-0 bg-black/40 flex items-center justify-center z-50">

  <div class="bg-white w-full max-w-lg rounded-xl shadow-xl p-6">

    <div class="flex justify-between items-center mb-4">
      <h3 class="text-lg font-bold text-slate-800">AI Reply</h3>

      <button
        class="text-slate-500 hover:text-slate-700"
        @click="aiModal=false"
      >
        ✕
      </button>
    </div>

    <textarea
      v-model="aiReplyText"
      rows="6"
      class="w-full border border-slate-200 rounded-lg p-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
      placeholder="Write or generate AI reply..."
    ></textarea>

    <div class="flex justify-end gap-2 mt-4">

      <button
        class="px-4 py-2 text-sm font-bold bg-slate-100 rounded-lg"
        @click="aiModal=false"
      >
        Cancel
      </button>

      <button
        class="px-4 py-2 text-sm font-bold bg-primary text-white rounded-lg"
        @click="sendReply"
      >
        Send Reply
      </button>

    </div>

  </div>
</div>
  </div>
</template>

<script>

  import { apiBaseUrl } from "@/apis/appconst";
  import {useToast} from 'vue-toastification';
  import {
    getReviewList,
    getReviewKpiStats,
    updateReviewStatus
  } from "../apis/reviewapis";   // adjust path if needed

   import {
    sendAiReplay
  } from "../apis/dashapis";

   import {
    getCampaignList
  } from "../apis/campaignapis";

  export default {
    name: "ReviewListScreen",

    data() {
      return {
        toast:null,
        aiModal: false,
        aiReplyText: "",
        selectedReview: null,
        activeStarFilters: [],
        review_user: "",
        showTxt:"",
        tmpTxt:"",
        activePopup: null,
        camps:[],

        /* KPI DATA */
        kpis: {
          avg_rating: 0,
          total_reviews: 0,
          negative_reviews: 0,
          review_velocity: 0
        },

        /* FILTERS */
        filters: {
          rating: "All",
          status: "All"
        },

        selectedDate: "Last 30 Days",
        selectedPlatform: "All",
        searchQuery: "",
        selectedCampName:"All",
        selectedCampid:"",
        page: 0,
        pageSize: 10,      // ⭐ IMPORTANT (match backend limit)
        totalReviews: 0,

        reviews: []
      };
    },
    computed: {

      totalPages() {
        return Math.ceil(this.totalReviews / this.pageSize);
      }
    },
    async mounted() {
      this.toast = useToast();
      const tmp = sessionStorage.getItem("ldata") || "";
      if (tmp && tmp.length > 0) {
        this.review_user = JSON.parse(tmp).user_id;
      }
      document.addEventListener("click", this.handleOutsideClick);

      await this.loadKpis();
      await this.loadReviews();
      await this.loadCamps();
    },

    beforeUnmount() {
      document.removeEventListener("click", this.handleOutsideClick);
    },

    watch: {
      searchQuery() {
        this.page = 0;          // reset pagination
        this.loadReviews(); // avoid spam calls
      }
    },
    methods: {
      isEmail(value) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(value);
      },
       async sendReply() {
          if (!this.aiReplyText) return;

          console.log("Replying to:", this.selectedReview.review_id);
          console.log("Reply:", this.aiReplyText);

           const res1 = await sendAiReplay(this.aiReplyText,this.selectedReview.review_id);
            if (res1.status) {
              this.aiModal = false;
              this.toast.success("Replay Sent!!");
              this.loadReviews();
            }
            else{
              this.toast.error("Failed");
            }

          
        },
      openAiReply(review) {
        this.selectedReview = review;
        this.aiReplyText = "";
        this.aiModal = true;
      },
       readMore(tmptxt,id,rtype){
        if(rtype===1){
          this.tmpTxt = tmptxt;
          this.showTxt = id;
        }
        else{
           this.tmpTxt = "";
          this.showTxt = "";
        }
      },
      getShrt(tmptxt){
        if(tmptxt.length>100){
           return (tmptxt+"").substring(0,100)+"...";
        }
        return tmptxt;
      },
      selectAllLeads() {
        this.selectedLeadFilter = "All Leads";
        this.activeStarFilters = [];
        this.loadReviews();
      },

      toggleStarDropdown() {
        this.activePopup =
          this.activePopup === "stars" ? null : "stars";
      },

      clearStars() {
        this.activeStarFilters = [];
      },

      async applyStarFilter() {
        this.selectedLeadFilter = "Star Filter";
        this.activePopup = null;
        await this.loadReviews();
      },
      beautifyDate(datetime) {
        if (!datetime) return "";

        const date = new Date(datetime.replace(" ", "T"));

        return date.toLocaleString("en-IN", {
          day: "numeric",
          month: "short",
          year: "numeric",
          hour: "numeric",
          minute: "2-digit"
        });
      },
      platformLogo(platform,rating) {
        if(parseInt(rating)>3){
          if ((platform + "").includes("google")) return "/images/google.png";
          if ((platform + "").includes("facebook")) return "/images/facebook.png";
        }
        return "/images/logo.png";
      },
      expNow() {
        const url = apiBaseUrl + "exp/review/export?review_user=" + this.review_user + "&review_platform=" + this.platform + "&duration=" + this.duration + "&buss_id=" + JSON.parse(sessionStorage.getItem("myBuss")).buss_id;
        // alert(url+"");
        window.open(
          url,
          "_blank",
          "noopener,noreferrer"
        );
      },
      /* ================= LOAD KPIs ================= */
      nextPage() {
        if (this.page + 1 >= this.totalPages) return;
        this.loadReviews(this.page + 1);
      },

      prevPage() {
        if (this.page === 0) return;
        this.loadReviews(this.page - 1);
      },
      async loadKpis() {
        const res = await getReviewKpiStats(this.review_user,this.selectedCampid);

        if (!res.status) return;

        this.kpis = res.data;
        this.totalReviews = parseInt(res.data.total_reviews);
      },

      /* ================= LOAD REVIEWS ================= */

      async loadReviews(newPage = this.page) {

        this.page = newPage;

        const durationMap = {
          "Today": "today",
          "Last 7 Days": "7",
          "Last 30 Days": "30",
          "Last 90 Days": "90"
        };

        const platform =
          this.selectedPlatform === "All" ? "" : this.selectedPlatform;

        const duration = durationMap[this.selectedDate] || "30";

        const res = await getReviewList(
          this.review_user,
          platform,this.selectedCampid,
          this.searchQuery,
          this.activeStarFilters,
          duration,
          (this.page).toString()   // ⭐ OFFSET PAGINATION
        );

        if (!res.status) return;

        this.reviews = res.reviews;
      },

      async loadCamps() {



        const res = await getCampaignList(
          this.review_user,
          "","","","","" 
        );

        if (!res.status) return;

        this.camps = res.campaigns;
      },

      /* ================= UI FILTER ACTIONS ================= */

      async selectPlatform(value) {
        this.selectedPlatform = value;
        this.activePopup = null;
        await this.loadReviews();
      },
       async selectCamp(camp_id,camp_title) {
        this.selectedCampid = camp_id;
        this.selectedCampName = camp_title;
        this.activePopup = null;
        this.loadReviews();
        this.loadKpis();
      },

      async selectDate(value) {
        this.selectedDate = value;
        this.activePopup = null;
        await this.loadReviews();
      },

      async applyFilters() {
        this.activePopup = null;
        await this.loadReviews();
      },

      async resetFilters() {
        this.filters.rating = "All";
        this.filters.status = "All";
        await this.loadReviews();
      },

      /* ================= STATUS UPDATE ================= */

      async changeStatus(review, status) {

        const res = await updateReviewStatus(
          review.review_id,
          status
        );

        if (!res.status) return;

        review.review_status = status;
        this.activePopup = null;
      },

      /* ================= HELPERS ================= */

      getInitials(name) {
        if (!name) return "NA";

        return name
          .split(" ")
          .map(n => n[0])
          .join("")
          .substring(0, 2)
          .toUpperCase();
      },

      toggleMenu(id) {
        this.activePopup = this.activePopup === id ? null : id;
      },

      togglePlatformDropdown() {
        this.activePopup =
          this.activePopup === "platform" ? null : "platform";
      },
      toggleCamppDropdown() {
        this.activePopup =
          this.activePopup === "camp" ? null : "camp";
      },

      toggleDateDropdown() {
        this.activePopup =
          this.activePopup === "date" ? null : "date";
      },

      toggleFiltersPanel() {
        this.activePopup =
          this.activePopup === "filters" ? null : "filters";
      },

      handleOutsideClick(e) {
        if (!this.$el.contains(e.target)) {
          this.activePopup = null;
        }
      }
    }
  };
</script>
<style scoped>
  .reviews-page {
    padding: 28px;
    display: flex;
    flex-direction: column;
    gap: 18px;
  }

  /* METRICS */
  .metrics-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 14px;
  }

  .metric-card {
    background: white;
    border-radius: 14px;
    padding: 16px;
    border: 1px solid #e2e8f0;
  }

  .metric-head {
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    color: #64748b;
  }

  .metric-value {
    font-size: 22px;
    font-weight: 800;
    margin-top: 6px;
    display: flex;
    gap: 10px;
  }

  .positive {
    color: #16a34a;
  }

  .danger {
    color: #ef4444;
  }

  .warning {
    color: #f59e0b;
  }

  .primary {
    color: #197fe6;
  }

  .neutral {
    color: #94a3b8;
  }

  /* TOOLBAR */
  .toolbar {
    background: white;
    padding: 12px;
    border-radius: 14px;
    border: 1px solid #e2e8f0;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;
  }

  .search-box {
    background: #f1f5f9;
    border-radius: 10px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    gap: 6px;
    height: 38px;
  }

  .search-box input {
    border: none;
    background: transparent;
    outline: none;
  }

  .filter-btn {
    height: 38px;
    padding: 0 12px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: #f8fafc;
  }

  /* TABLE */
  .table-card {
    background: white;
    border-radius: 16px;
    border: 1px solid #e2e8f0;
    overflow-x: auto;
  }

  table {
    width: 100%;
    min-width: 900px;
  }

  th {
    font-size: 11px;
    text-transform: uppercase;
    color: #64748b;
    padding: 14px;
  }

  td {
    padding: 16px 14px;
    font-size: 14px;
  }

  .customer-cell {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .avatar {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: #197fe6;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 700;
  }

  .stars .filled {
    color: #f59e0b;
  }

  .platform {
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 700;
  }

  .platform.google {
    background: #fef2f2;
    color: #dc2626;
  }

  .platform.facebook {
    background: #eff6ff;
    color: #2563eb;
  }

  .status {
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 700;
  }

  .status.pending {
    background: #fef9c3;
  }

  .status.replied {
    background: #dcfce7;
  }

  .status.flagged {
    background: #fee2e2;
  }

  .pagination {
    padding: 14px;
    border-top: 1px solid #e2e8f0;
    display: flex;
    justify-content: space-between;
  }

  /* MOBILE */
  @media(max-width:768px) {
    .reviews-page {
      padding: 16px;
    }

    table {
      min-width: 700px;
    }
  }

  /* ================= PAGE STRUCTURE ================= */

  .reviews-page {
    padding: 28px;
    display: flex;
    flex-direction: column;
    gap: 18px;
    background: #f6f7f8;
  }

  /* ================= METRICS STRIP ================= */

  .metrics-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 14px;
  }

  .metric-card {
    background: white;
    border-radius: 16px;
    padding: 18px;
    border: 1px solid #e2e8f0;
    transition: 0.2s;
  }

  .metric-card:hover {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04);
  }

  .metric-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    font-weight: 600;
    color: #64748b;
  }

  .metric-value {
    font-size: 26px;
    font-weight: 800;
    margin-top: 6px;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .metric-value small {
    font-size: 12px;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 2px;
  }

  .metric-value .material-symbols-outlined {
    font-size: 16px;
  }

  /* ================= TOOLBAR ================= */

  .toolbar {
    background: white;
    padding: 12px;
    border-radius: 16px;
    border: 1px solid #e2e8f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
  }

  .toolbar-left,
  .toolbar-right {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  /* SEARCH */

  .search-box {
    background: #f1f5f9;
    border-radius: 12px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    gap: 6px;
    height: 40px;
    min-width: 260px;
  }

  .search-box span {
    font-size: 18px;
    color: #94a3b8;
  }

  .search-box input {
    border: none;
    background: transparent;
    outline: none;
    font-size: 13px;
    width: 100%;
  }

  /* FILTER BUTTONS */

  .filter-btn {
    height: 40px;
    padding: 0 14px;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    background: #f8fafc;
    font-size: 13px;
    font-weight: 600;
    color: #334155;
    display: flex;
    align-items: center;
    gap: 6px;
    transition: 0.2s;
  }

  .filter-btn:hover {
    background: #f1f5f9;
  }

  /* ACTION BUTTONS */

  .ghost-btn {
    height: 40px;
    padding: 0 16px;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    background: white;
    font-size: 13px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .primary-btn {
    height: 40px;
    padding: 0 18px;
    border-radius: 12px;
    border: none;
    background: #197fe6;
    color: white;
    font-size: 13px;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 6px;
    transition: 0.2s;
  }

  .primary-btn:hover {
    background: #166fd1;
  }

  /* ================= TABLE CARD ================= */

  .table-card {
    background: white;
    border-radius: 18px;
    border: 1px solid #e2e8f0;
    overflow: hidden;
  }

  /* TABLE */

  .table-card table {
    width: 100%;
    border-collapse: collapse;
  }

  .table-card thead {
    background: #f8fafc;
  }

  .table-card th {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    color: #64748b;
    padding: 14px;
    letter-spacing: 0.4px;
  }

  .table-card td {
    padding: 16px 14px;
    font-size: 14px;
    border-top: 1px solid #f1f5f9;
    vertical-align: middle;
  }

  /* ROW HOVER */

  .table-card tbody tr:hover {
    background: #f8fafc;
  }

  /* CUSTOMER CELL */

  .customer-cell {
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 600;
  }

  .avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #197fe6;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 700;
    flex-shrink: 0;
  }

  /* STARS */

  .stars {
    display: flex;
    gap: 2px;
  }

  .stars .material-symbols-outlined {
    font-size: 18px;
    color: #e2e8f0;
  }

  .stars .filled {
    color: #f59e0b;
  }

  /* PLATFORM BADGES */

  .platform {
    padding: 5px 12px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 700;
    white-space: nowrap;
  }

  .platform.google {
    background: #fef2f2;
    color: #dc2626;
  }

  .platform.facebook {
    background: #eff6ff;
    color: #2563eb;
  }

  /* REVIEW TEXT */

  .review-text {
    color: #334155;
    max-width: 380px;
    text-overflow: ellipsis;
  }

  /* STATUS BADGES */

  .status {
    padding: 5px 12px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 700;
  }

  .status.pending {
    background: #fef9c3;
    color: #854d0e;
  }

  .status.replied {
    background: #dcfce7;
    color: #166534;
  }

  .status.flagged {
    background: #fee2e2;
    color: #991b1b;
  }

  /* ACTION BUTTON */

  .mini-btn {
    width: 34px;
    height: 34px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: white;
    font-size: 16px;
    cursor: pointer;
  }

  .mini-btn:hover {
    background: #f8fafc;
  }

  /* ================= PAGINATION ================= */

  .pagination {
    padding: 16px;
    border-top: 1px solid #f1f5f9;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    color: #64748b;
    flex-wrap: wrap;
    gap: 10px;
  }

  .pages {
    display: flex;
    gap: 6px;
  }

  .pages button {
    width: 34px;
    height: 34px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: white;
    font-size: 13px;
    font-weight: 600;
  }

  .pages button.active {
    background: #197fe6;
    color: white;
    border-color: #197fe6;
  }

  /* ================= MOBILE RESPONSIVE ================= */

  @media (max-width: 768px) {

    .reviews-page {
      padding: 16px;
      gap: 14px;
    }

    .metrics-grid {
      grid-template-columns: 1fr;
    }

    .toolbar {
      flex-direction: column;
      align-items: stretch;
    }

    .toolbar-left,
    .toolbar-right {
      width: 100%;
    }

    .search-box {
      min-width: 100%;
    }

    .filter-btn,
    .ghost-btn,
    .primary-btn {
      width: 100%;
      justify-content: center;
    }

    .table-card {
      overflow-x: auto;
    }

    .review-text {
      max-width: 240px;
    }

    .pagination {
      flex-direction: column;
      align-items: flex-start;
    }

  }

  .actions-menu {
    position: absolute;
    background: white;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    padding: 6px;
    width: 140px;
    right: 20px;
    margin-top: 6px;
    z-index: 10;
  }

  .actions-menu div {
    padding: 8px 10px;
    font-size: 12px;
    cursor: pointer;
    border-radius: 8px;
  }

  .actions-menu div:hover {
    background: #f1f5f9;
  }

  .actions-menu .danger {
    color: #ef4444;
  }

  .dropdown-wrapper {
    position: relative;
  }

  .dropdown-menu {
    position: absolute;
    top: 46px;
    left: 0;
    background: white;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    width: 160px;
    padding: 6px;
    z-index: 20;
  }

  .dropdown-menu div {
    padding: 9px 12px;
    font-size: 13px;
    cursor: pointer;
    border-radius: 8px;
    font-weight: 500;
  }

  .dropdown-menu div:hover {
    background: #f1f5f9;
  }

  .filters-panel {
    position: absolute;
    top: 48px;
    right: 0;
    width: 240px;
    background: white;
    border-radius: 14px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
    padding: 14px;
    z-index: 50;
  }

  .filter-group {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 10px;
  }

  .filter-group label {
    font-size: 11px;
    font-weight: 700;
    color: #64748b;
    text-transform: uppercase;
  }

  .filter-group select {
    height: 36px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    padding: 0 10px;
    font-size: 13px;
    outline: none;
  }

  .filter-actions {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
  }

  .small {
    height: 34px;
    font-size: 12px;
  }

  .platform.review {
    background: #eef2ff;
    color: #4f46e5;
  }

  .platform.referral {
    background: #fff7ed;
    color: #ea580c;
  }

  .source-logo {
    width: 28px;
    height: 28px;
    object-fit: contain;
  }
  /* ===== TOP FILTER TABS ===== */

.top-filters {
  display: flex;
  gap: 8px;
  align-items: center;
}

.tab-btn {
  height: 38px;
  padding: 0 14px;
  border-radius: 20px;
  border: 1px solid #e2e8f0;
  background: white;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s;
}

.tab-btn:hover {
  background: #f1f5f9;
}

.tab-btn.active {
  background: #197fe6;
  color: white;
  border-color: #197fe6;
}

.small-icon {
  font-size: 16px;
  margin-left: 4px;
}

/* STAR DROPDOWN */

.star-dropdown {
  width: 180px;
}

.checkbox-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  font-size: 13px;
  cursor: pointer;
}

.checkbox-row input {
  accent-color: #197fe6;
}

.dropdown-actions {
  display: flex;
  justify-content: space-between;
  padding: 8px;
}

.ai-btn {
  padding: 6px 12px;
  font-size: 11px;
  font-weight: 700;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  background: linear-gradient(135deg, #000000, #000000);
  color: white;
  transition: 0.2s ease;
}

.ai-btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}
</style>